export default "__VITE_ASSET__cce5880f__"